import './faq-block.scss';

export default () => {

};$( '.js-accordion' ).click( function () {
	let sib = $( this ).parent().siblings();

	$( this ).parent( '.faq-block__item' ).find( '.faq-block__content' ).slideToggle();
	$( this ).parent( '.faq-block__item' ).prevAll( '.faq-block__item' ).find( '.faq-block__content' ).slideUp();
	$( this ).parent( '.faq-block__item' ).nextAll( '.faq-block__item' ).find( '.faq-block__content' ).slideUp();
	sib.removeClass( 'active' );
	$( this ).parent().toggleClass( 'active' );
} );

